import { SmartReply } from '../messageForm/smartReply/smartReply';
import {
    EditSmartReplyCallback,
    EditSmartReplyQuery,
    WriteSmartReplyCallback,
    WriteSmartReplyQuery,
} from '@copilot/common/hooks/smartReply/smartReplyTypes';
import {
    TextEditorContextActions,
    useTextEditorContext,
} from '@copilot/common/components/forms/textEditor/context';
import { useEffect } from 'react';
import { isNil } from 'lodash';
import { isEmptyString } from '@copilot/common/utils/common';
import { SmartReplyPromptCategory } from '../messageForm/smartReply/promptMenu/promptMenuTypes';

/** Props for Text Editor Smart Reply Component */
export interface ITextEditorSmartReplyProps {
    isActive: boolean;
    canRegenerate: boolean;
    onRegenerate: () => void;
    setIsActive: (isActive: boolean) => void;
    onWrite: WriteSmartReplyCallback;
    data: WriteSmartReplyQuery | EditSmartReplyQuery;
    onEdit: EditSmartReplyCallback;
    smartReplyPromptCategory?: SmartReplyPromptCategory;
    canUseCommunicationStyles: boolean;
}

/**
 * SmartReply component for the Text Editor
 * @param props
 * @returns
 */
export function TextEditorSmartReply({
    isActive,
    canRegenerate,
    onRegenerate,
    setIsActive,
    onWrite,
    data,
    onEdit,
    smartReplyPromptCategory,
    canUseCommunicationStyles,
}: ITextEditorSmartReplyProps): JSX.Element {
    const { dispatchUpdate, text, disabled } = useTextEditorContext();

    useEffect(() => {
        if (isNil(data.data)) return;
        dispatchUpdate({ type: TextEditorContextActions.setText, payload: { text: data.data } });
    }, [data.data]);

    return (
        <SmartReply
            isActive={isActive}
            canRegenerate={canRegenerate}
            onRegenerate={onRegenerate}
            setIsActive={setIsActive}
            onWrite={onWrite}
            data={data}
            onEdit={(prompts: string, message?: string, includePersonalizedInsights?: boolean) =>
                onEdit(text, prompts, message, includePersonalizedInsights)
            }
            canUseCommunicationStyles={canUseCommunicationStyles}
            hasMessage={!isEmptyString(text)}
            disabled={disabled}
            smartReplyPromptCategory={smartReplyPromptCategory}
        />
    );
}
